import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import TrainRoundedIcon from "@mui/icons-material/TrainRounded";
import LocalMallRoundedIcon from "@mui/icons-material/LocalMallRounded";
import LocalHospitalRoundedIcon from "@mui/icons-material/LocalHospitalRounded";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import openMapLocation from "../utils/navigateLocation";
import "./Location.css";

const nearBy = [
  { icon: <TrainRoundedIcon />, title: "Ring Road Access", time: "3–5 min" },
  {
    icon: <LocalMallRoundedIcon />,
    title: "Shopping & Dining",
    time: "3-5 min",
  },
  { icon: <LocalHospitalRoundedIcon />, title: "Hospital", time: "1-2 min" },
  {
    icon: <DirectionsCarRoundedIcon />,
    title: "Business Hub",
    time: "0 min",
  },
];

const Location = () => {
  const { ref, inView } = useInView({ threshold: 0.18, triggerOnce: true });

  return (
    <section className="loc" id="location" ref={ref}>
      <div className="loc__container">
        <div className="loc__grid">
          {/* Left */}
          <motion.div
            className="loc__content"
            initial={{ opacity: 0, y: 14 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7 }}
          >
            <div className="loc__kicker">LOCATION</div>
            <h2 className="loc__title">
              Connected, convenient, and easy to reach.
            </h2>
            <p className="loc__sub">
              A location that keeps your daily life simple — quick access to
              main roads, nearby essentials, and the places you actually go.
            </p>

            <div className="loc__address">
              <div className="loc__pin">
                <LocationOnRoundedIcon />
              </div>
              <div>
                <div className="loc__addressTitle">Project Address</div>
                <div className="loc__addressText">
                  5-B Main Boulevard, Downtown Commercial, Al Kabir Town Phase
                  2, Raiwind Road, Lahore (Near Lake City)
                </div>
              </div>
            </div>

            <div className="loc__nearGrid">
              {nearBy.map((n, idx) => (
                <motion.div
                  className="loc__nearCard"
                  key={idx}
                  initial={{ opacity: 0, y: 10 }}
                  animate={inView ? { opacity: 1, y: 0 } : {}}
                  transition={{ duration: 0.55, delay: 0.06 * idx }}
                >
                  <div className="loc__nearIcon">{n.icon}</div>
                  <div className="loc__nearText">
                    <div className="loc__nearTitle">{n.title}</div>
                    <div className="loc__nearTime">{n.time}</div>
                  </div>
                </motion.div>
              ))}
            </div>

            <div className="loc__actions">
              <button
                onClick={() => {
                  openMapLocation();
                }}
                className="loc__btn loc__btn--primary"
              >
                Get Directions <ArrowOutwardRoundedIcon />
              </button>
              <button
                onClick={() => {
                  openMapLocation();
                }}
                className="loc__btn loc__btn--ghost"
              >
                Nearby Places <ArrowOutwardRoundedIcon />
              </button>
            </div>
          </motion.div>

          {/* Right Map */}
          <motion.div
            className="loc__map"
            initial={{ opacity: 0, y: 14 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.7, delay: 0.08 }}
          >
            <div className="loc__mapFrame">
              {/* ✅ Replace this embed link with your own */}
              <iframe
                title="Project Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3407.5140488506095!2d74.23555637527878!3d31.344791055796215!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3919ab55c12e7dd5%3A0xc81f7a5650dada24!2sHB%20HEIGHT!5e0!3m2!1sen!2s!4v1771053226722!5m2!1sen!2s"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>

            {/* <div className="loc__mapNote">
              Tip: later we’ll replace this with your exact Google embed URL.
            </div> */}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Location;
